<template>
  <div class="projektleiter">
    <v-row>
      <v-col>
        <h3>Projektleiter</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-select
          label="Anrede"
          type="text"
          v-model="projektleiter_anrede"
          :items="anredenListe"
        />
      </v-col>
      <v-col>
        <v-combobox
          class="pt-1"
          label="Titel"
          type="text"
          v-model="projektleiter_titel"
          :items="titelListe"
          hideDetails="auto"
          outlined
          dense
          @change="adaptTitle()"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Vorname"
          type="text"
          v-model="projektleiter_vorname"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Nachname"
          type="text"
          v-model="projektleiter_nachname"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-text-field
          label="Telefon"
          type="text"
          v-model="projektleiter_telefon"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Email"
          type="text"
          v-model="projektleiter_email"
          :rules="[validations.required, validations.emailValidation]"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Institution"
          type="text"
          v-model="projektleiter_institution"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-text-field
          label="Adresse"
          type="text"
          v-model="projektleiter_adresse"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="PLZ"
          type="text"
          v-model="projektleiter_plz"
          :rules="[validations.plzDeutschland]"
        />
      </v-col>
      <v-col>
        <b-text-field label="Stadt" type="text" v-model="projektleiter_stadt" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import anreden from '@/utils/data/anreden';
import titel from '@/utils/data/titel';
import validations from '@/service/validations';

export default {
  name: 'Projektleiter',
  data() {
    return {
      titelListe: titel,
      anredenListe: anreden,
      validations: validations
    };
  },
  mixins: [
    dataMixin(
      'projektleiter_anrede',
      'persistentData.projekt.projektLeiter.anrede'
    ),
    dataMixin(
      'projektleiter_titel',
      'persistentData.projekt.projektLeiter.titel'
    ),
    dataMixin(
      'projektleiter_vorname',
      'persistentData.projekt.projektLeiter.vorname'
    ),
    dataMixin(
      'projektleiter_nachname',
      'persistentData.projekt.projektLeiter.nachname'
    ),

    dataMixin(
      'projektleiter_telefon',
      'persistentData.projekt.projektLeiter.telefon'
    ),
    dataMixin(
      'projektleiter_email',
      'persistentData.projekt.projektLeiter.email'
    ),
    dataMixin(
      'projektleiter_institution',
      'persistentData.projekt.projektLeiter.institution'
    ),

    dataMixin(
      'projektleiter_adresse',
      'persistentData.projekt.projektLeiter.adresse'
    ),
    dataMixin('projektleiter_plz', 'persistentData.projekt.projektLeiter.plz'),
    dataMixin(
      'projektleiter_stadt',
      'persistentData.projekt.projektLeiter.stadt'
    ),
  ],
  methods: {
    adaptTitle() {
      const title = this.projektleiter_titel;
      if (title.value) {
        this.projektleiter_titel = title.value;
      }
    }
  },
};
</script>

<style scoped>
</style>

